import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/NewStory.css';

function NewStory() {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [coverImage, setCoverImage] = useState(null);
  const [category, setCategory] = useState('');
  const [copyright, setCopyright] = useState('');
  const [isMatureContent, setIsMatureContent] = useState(false);
  const [coverImageError, setCoverImageError] = useState('');
  const [categoryError, setCategoryError] = useState('');
  const [copyrightError, setCopyrightError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const categories = [
    { id: 1, name: 'Aksiyon' }, { id: 2, name: 'Bilim Kurgu' }, { id: 3, name: 'Fantastik' }, 
    { id: 4, name: 'Genel Kurgu' }, { id: 5, name: 'Genç Kurgu' }, { id: 6, name: 'Gerilim' }, 
    { id: 7, name: 'Gizem' }, { id: 8, name: 'Hayran Kurgu' }, { id: 9, name: 'Klasikler' }, 
    { id: 10, name: 'Korku' }, { id: 11, name: 'Kısa Hikaye' }, { id: 12, name: 'Macera' }, 
    { id: 13, name: 'Mizah' }, { id: 14, name: 'Paranormal' }, { id: 15, name: 'Romantizm' }, 
    { id: 16, name: 'Spiritüel' }, { id: 17, name: 'Tarihi Kurgu' }, { id: 18, name: 'Texting' }, 
    { id: 19, name: 'Vampir' }, { id: 20, name: 'Şiir' }
  ];

  const copyrights = [
    { id: 1, name: 'Telif Hakkı Belirtilmemiş' }, { id: 2, name: 'Tüm Hakları Saklıdır' }, 
    { id: 3, name: 'Tüm Hakları Herkese Açık' }, { id: 4, name: 'Creative Commons (CC) İsnadı' }, 
    { id: 5, name: '(CC) Atıf-Gayriticari' }, { id: 6, name: '(CC) Atıf-Gayriticari-Türetilemez' }, 
    { id: 7, name: '(CC) Attrib. NonComm. Sürümleri ile' }, { id: 8, name: '(CC) Atıf-LisanDevam' }, 
    { id: 9, name: '(CC) Atıf-Türetilemez' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCoverImageError('');
    setCategoryError('');
    setCopyrightError('');

    let hasError = false;

    if (!coverImage) {
      setCoverImageError('Kapak fotoğrafı yüklenmelidir.');
      hasError = true;
    }

    if (!category) {
      setCategoryError('Kategori seçilmelidir.');
      hasError = true;
    }

    if (!copyright) {
      setCopyrightError('Telif hakkı seçilmelidir.');
      hasError = true;
    }

    if (hasError) {
      return;
    }

    setSubmitting(true);

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('cover_image', coverImage);
    formData.append('category_id', category);
    formData.append('telif_id', copyright);
    formData.append('is_mature_content', isMatureContent);

    const token = localStorage.getItem('token');
    
    if (!token) {
      setError('Oturum bilginiz bulunamadı. Lütfen tekrar giriş yapın.');
      setSubmitting(false);
      return;
    }

    try {
      console.log('Hikaye gönderiliyor...', {
        title,
        description,
        category,
        copyright,
        isMatureContent
      });
      
      const response = await api.post('/new-story', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });
      
      console.log('API Yanıtı:', response.data);
      
      if (response.data && response.data.book_id) {
        const createdBook = response.data;
        console.log('Hikaye başarıyla oluşturuldu, edit sayfasına yönlendiriliyor:', createdBook);
        
        // Yönlendirme burada gerçekleşiyor
        navigate('/edit-story', {
          state: { 
            bookId: createdBook.book_id, 
            title: createdBook.title, 
            content: '' 
          }
        });
      } else {
        setError('Hikaye oluşturuldu ancak ID alınamadı. Lütfen tekrar deneyin.');
        console.error('API yanıtında book_id bulunamadı:', response.data);
      }
    } catch (error) {
      console.error('Hikaye oluşturulurken hata:', error);
      setError('Hikaye oluşturulurken bir hata oluştu: ' + (error.response?.data?.message || error.message));
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleCoverImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setCoverImage(file);
      setCoverImageError('');
    }
  };

  return (
    <div className="new-story-page">
      <div className="new-story-container">
        <div className="story-header">
          <button className="back-button" onClick={handleCancel}>{'<'}</button>
          <h1>{title || 'İsimsiz Hikaye'}</h1>
          <div className="header-buttons">
            <button className="cancel-button" onClick={handleCancel}>İptal Et</button>
            <button 
              className="next-button" 
              onClick={handleSubmit} 
              disabled={submitting}
            >
              {submitting ? 'Gönderiliyor...' : 'Sonraki'}
            </button>
          </div>
        </div>

        {error && <div className="error-banner">{error}</div>}

        <div className="story-content">
          <div className="story-cover">
            <div className="cover-upload">
              {coverImage ? (
                <img src={URL.createObjectURL(coverImage)} alt="Kapak" />
              ) : (
                <div className="upload-placeholder">
                  <i className="icon-placeholder" />
                  <span>Kapak ekle</span>
                </div>
              )}
              <input
                type="file"
                onChange={handleCoverImageChange}
                accept="image/*"
              />
              {coverImageError && <div className="error-message">{coverImageError}</div>}
            </div>
          </div>

          <div className="story-details">
            <h2>Hikaye Ayrıntıları</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <h3>Başlık</h3>
                <input
                  id="title"
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Başlık"
                  required
                />
              </div>

              <div className="form-group">
                <h3>Açıklama</h3>
                <textarea
                  id="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Açıklama"
                />
              </div>

              <div className="form-group">
                <h3>Kategoriler</h3>
                <select
                  id="category"
                  value={category}
                  onChange={(e) => {
                    setCategory(e.target.value);
                    setCategoryError('');
                  }}
                >
                  <option value="">Bir kategori seç</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
                {categoryError && <div className="error-message">{categoryError}</div>}
              </div>

              <div className="form-group">
                <h3>Telif Hakkı</h3>
                <select
                  id="copyright"
                  value={copyright}
                  onChange={(e) => {
                    setCopyright(e.target.value);
                    setCopyrightError('');
                  }}
                >
                  <option value="">Telif Hakkı Seç</option>
                  {copyrights.map((copy) => (
                    <option key={copy.id} value={copy.id}>{copy.name}</option>
                  ))}
                </select>
                {copyrightError && <div className="error-message">{copyrightError}</div>}
              </div>

              <div className="form-group">
                <h3>Yetişkin İçerik</h3>
                <select
                  id="isMatureContent"
                  value={isMatureContent ? 'true' : 'false'}
                  onChange={(e) => setIsMatureContent(e.target.value === 'true')}
                >
                  <option value="false">Diğer</option>
                  <option value="true">Yetişkin İçerik</option>
                </select>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewStory;